import * as zod from "zod";

export interface TranslatedText {
  languageCode: string;
  name: string;
}

export const translatedTextSchema = zod.object({
  languageCode: zod.string().length(2),
  name: zod.string(),
});
